<div class="header">
  <div>
    <h2>{{ 'menu.admin.connections' | translate }}</h2>
  </div>
</div>

<nb-card>
  <nb-card-body class="table">
    <app-table
      #table
      rowIdKey="datatype_id"
      [title]="title"
      [columns]="columns"
      [data]="connections.value"
      [rowActions]="[]"
      [globalActions]="[]"
      (event)="onEvent($event)"
      [maxVisibleItems]="500"
    ></app-table>
  </nb-card-body>
</nb-card>
